// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-sidebar {
  display: none;
  background: white !important;
  width: 256px !important;
  min-width: 256px !important;
  max-width: 256px !important;
}
.c-sidebar-collapsed {
  width: 64px !important;
  min-width: 64px !important;
  max-width: 64px !important;
}
.c-sidebar .c-menu {
  background: transparent;
  height: 100vh;
  padding-inline: 8px;
}
@media only screen and (min-width: 1024px) {
  .c-sidebar {
    display: block;
  }
}
.c-sidebar .collapse-btn {
  position: absolute;
  inset-inline-end: -12px;
  inset-block-start: 12px;
  z-index: 101;
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.c-sidebar .collapse-btn .ant-btn-icon {
  line-height: 0;
}
.c-sidebar .collapse-btn .anticon {
  font-size: 12px !important;
}
.c-sidebar .ant-menu-item {
  padding-left: 16px !important;
}

.c-drawer-sidebar__body {
  padding: 12px 0 !important;
  overflow: hidden !important;
}
.c-drawer-sidebar__body .c-menu {
  background: transparent;
  height: 100vh;
  padding-inline: 8px;
}`, "",{"version":3,"sources":["webpack://./src/layout/Sidebar/style.scss","webpack://./src/styles/base/_responsive.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,4BAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;AADF;AAGE;EACE,sBAAA;EACA,0BAAA;EACA,0BAAA;AADJ;AAIE;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;AAFJ;ACII;EDlBJ;IAoBI,cAAA;EAFF;AACF;AAIE;EACE,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFJ;AAII;EACE,cAAA;AAFN;AAKI;EACE,0BAAA;AAHN;AAOE;EACE,6BAAA;AALJ;;AASA;EACE,0BAAA;EACA,2BAAA;AANF;AAQE;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;AANJ","sourcesContent":["@import '@/styles/base/responsive';\n\n.c-sidebar {\n  display: none;\n  background: white !important;\n  width: 256px !important;\n  min-width: 256px !important;\n  max-width: 256px !important;\n\n  &-collapsed {\n    width: 64px !important;\n    min-width: 64px !important;\n    max-width: 64px !important;\n  }\n\n  .c-menu {\n    background: transparent;\n    height: 100vh;\n    padding-inline: 8px;\n  }\n\n  @include Responsive(LG) {\n    display: block;\n  }\n\n  .collapse-btn {\n    position: absolute;\n    inset-inline-end: -12px;\n    inset-block-start: 12px;\n    z-index: 101;\n    width: 24px !important;\n    height: 24px !important;\n    min-width: 24px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .ant-btn-icon {\n      line-height: 0;\n    }\n\n    .anticon {\n      font-size: 12px !important;\n    }\n  }\n\n  .ant-menu-item {\n    padding-left: 16px !important;\n  }\n}\n\n.c-drawer-sidebar__body {\n  padding: 12px 0 !important;\n  overflow: hidden !important;\n\n  .c-menu {\n    background: transparent;\n    height: 100vh;\n    padding-inline: 8px;\n  }\n}\n","$SM: 640px;\n$MD: 768px;\n$LG: 1024px;\n$XL: 1280px;\n$XXL: 1536px;\n\n@mixin Responsive($screen) {\n  @if $screen==SM {\n    @media only screen and (min-width: $SM) {\n      @content;\n    }\n  }\n\n  @if $screen==MD {\n    @media only screen and (min-width: $MD) {\n      @content;\n    }\n  }\n\n  @if $screen==LG {\n    @media only screen and (min-width: $LG) {\n      @content;\n    }\n  }\n\n  @if $screen==XL {\n    @media only screen and (min-width: $XL) {\n      @content;\n    }\n  } @else if $screen==XXL {\n    @media only screen and (min-width: $XXL) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
